import { render, staticRenderFns } from "./article-impact-modal.vue?vue&type=template&id=72352981&scoped=true&"
import script from "./article-impact-modal.vue?vue&type=script&lang=ts&"
export * from "./article-impact-modal.vue?vue&type=script&lang=ts&"
import style0 from "./article-impact-modal.vue?vue&type=style&index=0&id=72352981&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72352981",
  null
  
)

export default component.exports